export default __webpack_public_path__ + "static/media/Superdiversity-website-metadata-Auckland.ebd7f248.pdf";